<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="predictions"
    item-key="id"
    show-select
    :items-per-page="-1"
  >
    <template v-slot:item.image="{ item }" >
      <v-img :src="item.image" 
        width="100px" 
      ></v-img>
    </template>
    <template v-slot:top>
      <v-dialog v-model="dialog" persistent max-width="390">
        <template v-slot:activator="{ on, attrs }">
          <div class="pb-4">開催中の予想（通報用）</div>
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            チェックした予想を次の理由で無効にする
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">確認</v-card-title>
          <v-card-text>
            選択された予想を無効にします。よろしいですか？
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="disablePredictions">OK</v-btn>
            <v-btn color="green darken-1" text @click="dialog = false">キャンセル</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-radio-group v-model="reason" row>
        <v-radio label="公序良俗に反する" value="11"></v-radio>
        <v-radio label="公平性に欠ける" value="12"></v-radio>
        <v-radio label="正解が明確でない" value="13"></v-radio>
        <v-radio label="予想になっていない" value="14"></v-radio>
        <v-radio label="その他" value="15"></v-radio>
      </v-radio-group>      
    </template>  
  </v-data-table>
</template>

<script>
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        dialog: false,
        reason: '11',
        db: null,
        selected: [],
        headers: [
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: '作成日時', value: 'createdAt' },
          { text: '更新日時', value: 'updatedAt' },
          { text: '出題者', value: 'creatorName' },
          { text: 'カテゴリー', value: 'categoryName' },
          { text: '予想タイトル', value: 'predictionTitle' },
          { text: 'リンク', value: 'link' },
          { text: '画像', value: 'image' },
          { text: '予想本文', value: 'predictionBody' },
          { text: '回答', value: 'choice' },
          { text: '通報', value: 'badCount' },
        ],
        predictions: []
      }
    },
    methods: {
      disablePredictions () {
        let promises = []
        for (const row of this.selected) {
          let promise = this.$fb.updateDoc(
            this.$fb.doc(
              this.$fb.firestore,
              'prediction',
              row.id
            ), {
              is_invalid: true,
              invalid_reason_cd: this.reason,
              updated_at: new Date()
            }
          )
          promises.push(promise)
        }
        Promise.all(promises).then(() => {
          location.reload()
        }).catch (error => {
          console.error(error)
        })
      },
      getPredictions () {
        this.$fb.getDocs(this.$fb.query(this.$fb.collection(this.$fb.firestore, 'prediction')
          .withConverter(this.predictionConverter),
          this.$fb.where('close_at', '>=', new Date()),
          this.$fb.where('is_published', '==', true),
          this.$fb.where('is_invalid', '==', false),
          this.$fb.where('is_finalized', '==', false),
          this.$fb.orderBy('close_at', 'asc'),
          this.$fb.limit(1000)))
          .then(predictionSnap => {
            this.predictions = []
            predictionSnap.forEach(predictionDoc => {
              let prediction = predictionDoc.data()
              prediction.createdAt = prediction.createdAt.toLocaleString()
              prediction.updatedAt = prediction.updatedAt.toLocaleString()
              prediction.categoryName = this.getCategoryName(prediction.categoryId)
              const link = []
              if (prediction.link1) link.push(prediction.link1)
              if (prediction.link2) link.push(prediction.link2)
              if (prediction.link3) link.push(prediction.link3)
              prediction.link = link.join('\n')
              prediction.badCount = prediction.bad?.length ?? 0
              console.log(`path: ${prediction.imagePath}`)
              const imageRef = this.$fb.ref(this.$fb.storage, prediction.imagePath)
              console.log(imageRef)
              const storagePromise = prediction.imagePath ? this.$fb.getDownloadURL(imageRef) : Promise.resolve()
              const usersPromise = this.$fb.getDoc(this.$fb.doc(this.$fb.firestore, 'users', prediction.creatorId)
                .withConverter(this.userConverter))
              const choicePromise = this.$fb.getDocs(this.$fb.collection(this.$fb.firestore, 'prediction', predictionDoc.id, 'choice')
                .withConverter(this.choiceConverter))
              const promiseArray = [
                storagePromise,
                usersPromise,
                choicePromise,
              ]
              Promise.all(promiseArray).then(resultArray => {
                const url = resultArray[0]
                const usersDoc = resultArray[1]
                const choiceSnap = resultArray[2]
                prediction.image = url
                prediction.creatorName = usersDoc.data().nickname
                let choice = ''
                choiceSnap.forEach(choiceDoc => {
                  choice = choice + choiceDoc.data().choice + ', '
                })
                prediction.choice = choice
                this.predictions.push(prediction)
              })
            })
          }).catch(error => {
            console.error(error)
            this.predictions = []
          })
      },
    },
    created () {
      this.getPredictions()
    }
  }
</script>